export const UsersData = [
    { email: "DV_901@gmail.com", password: '1234', role: "DV_901" },
    { email: "DV_EDN@gmail.com", password: '1234', role: "DV_EDN" },
    { email: "LMS@gmail.com", password: '1234', role: "LMS" },
    { email: "LMS_EDN@gmail.com", password: '1234', role: "LMS_EDN" },
    { email: "EDP@gmail.com", password: '1234', role: "EDP" },
    { email: "EDP_EDN@gmail.com", password: '1234', role: "EDP_EDN" },
]